import PayLogicNarSassGetSaasCode, {
  PayLogicNarSassGetSaasCodeRes,
} from '@quickService/PayLogicNarSassGetSaasCode';
import { message } from '@tencent/tea-component';
import { openNewPage } from '@utils/open-new-pgae';

// https://cloud.tencent.com/open/authorize?scope=login&app_id=100021003676&redirect_url
// =https://meeting.tencent.com/user-center/cloud-auth-callback?state=KkLYh4A0KTvdhi2B

export interface ToSassParams {
  /** 目标跳转url，默认云主页 */
  targetUrl?: string;
  /** 跳转时是否展示loading，默认展示 */
  loading?: boolean;
  /** 自定义请求参数，设置后会覆盖默认参数 */
  reqData?: Record<string, any>;
  /** 1企业版| 11个人版 */
  corpCategory: 1 | 11;
  /** 操作类型，change_uin:换绑uin, get_uin_info: 获取uin等等 */
  doType?: string;
}

/**
 * 携带登录态跳转腾讯云的公共方法
 * @param targetUrl 腾讯云的目标页面
 * @param type 那种场景
 * @returns null
 */
const toSaas = (params: ToSassParams) => {
  const { loading = true, reqData, doType = '', corpCategory, targetUrl } = params;
  const loadingIns = loading
    ? message.loading({
        content: '跳转中',
      })
    : null;
  const reqParams = reqData
    ? reqData
    : {
        corp_category: corpCategory,
        do_type: doType,
      };
  return PayLogicNarSassGetSaasCode(reqParams)
    .then((response: PayLogicNarSassGetSaasCodeRes) => {
      if (response?.code === 0 && response.data && response.data.saas_code) {
        const jumpUrl = `https://cloud.tencent.com/login/saas/jumpLoginByCode?code=${
          response.data.saas_code
        }&platform=meeting${targetUrl ? `&s_url=${encodeURIComponent(targetUrl)}` : ''}`;
        openNewPage(jumpUrl);
        return;
      }
      if (
        // 需要跳转云授权
        response.code === 300100
      ) {
        const { NODE_ENV } = process.env;
        let { origin } = window.location;

        //  非正式环境都跳转到默认test（因云那边只能配置一个域名，与后台沟通，非正式环境目前只能支持默认test）
        if (NODE_ENV !== 'production' || origin.includes('test')) {
          origin = 'https://test.txmeeting.tencent.com';
        }
        openNewPage(
          `https://cloud.tencent.com/open/authorize?scope=login&app_id=${
            response.data.cloud_url_appid
          }&redirect_url=${encodeURIComponent(
            `${origin}/user-center/cloud-auth-callback?${
              targetUrl ? `sUrl=${encodeURIComponent(targetUrl)}&` : ''
            }state=${response.data.cloud_url_state}`,
          )}`,
        );
      }
      const { msg } = response;
      if (msg)
        message.error({
          content: msg,
        });
    })
    .finally(() => {
      loadingIns?.hide();
    });
};

export default toSaas;
